import React from 'react';
import './Chapters.scss';
function Chapter7() {
  return (
    <section className="chapter" style={{ marginBottom: '4rem' }}>
      <p className="chapter__paragraph">
        “It may be surprising,” Keske adds, “but the compute, the networking security, and the tools
        the artists can access by working virtually allow them to be more creative. And the result
        is a better viewer experience.”
      </p>
      <p className="chapter__paragraph">
        “Every human emotion we can put into an image,” he says, “that’s the reward.”
      </p>
    </section>
  );
}

export default Chapter7;
